import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LoginService } from '../login/login.service';
import moment from 'moment';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  token: any
  storedData: any
  fromDate: any
  toDate: any
  status: any
  userTypes: any
  usertype: any
  type: any
  selectedCard: any = 'Perfomance MIS'
  userTypesTelleCaller: any
  telleCallers: any = []
  selectedTellecallers: any = []
  dropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  selectUser: any;
  users: any = [];

  constructor(public loginService: LoginService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
    this.listUserType()
    this.listStaffs();

  }
  selectCard(card: string) {

    this.selectedCard = card;
    this.cdr.detectChanges(); // Force UI update

  }
  report() {
    if (this.usertype.userType == 'Backend Staff' || this.usertype.userType == 'Field Executive') {
      let data = {
        "userType": this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        "status": this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.ReportApi(this.token, data, 'performanceReport')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    } else if (this.usertype.userType == 'Tele Caller') {
      let data = {
        "userType": this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        "status": this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.ReportApi(this.token, data, 'teleCallerPerformanceReport')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    }







  }

  report1() {

    if (this.type == 'Call Performance MIS') {

      let date1:any = moment(this.fromDate + " "+"00:00");
      let date2:any = moment(this.toDate + " "+"23:59");
      let users:any = [];

     console.log(this.selectUser)
     this.selectUser.forEach((element:any) => {
          users.push(element._id)
     });

      let data = {
        // "userType":this.usertype._id,
        "fromDate": date1.utc().format(),
        "toDate": date2.utc().format(),
        "userId": users
      }
      console.log(data);
      this.loginService.callPerformanceReport(this.token, data)
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })
    }

    if (this.type == 'Email Count MIS') {

      let date1:any = moment(this.fromDate + " "+"00:00");
      let date2:any = moment(this.toDate + " "+"23:59");
      let users:any = [];

     console.log(this.selectUser)
     this.selectUser.forEach((element:any) => {
          users.push(element._id)
     });

      let data = {
        // "userType":this.usertype._id,
        "fromDate": date1.utc().format(),
        "toDate": date2.utc().format(),
        "userId": users
      }
      console.log(data);
      // this.loginService.callPerformanceReport(this.token, data)
      //   .subscribe((response: any) => {
      //     if (response.status === 1) {
      //       window.open(response.data, "_self")


      //     }
      //   })
    }
  }


  DataMISReport() {

    if (this.type == 'Data MIS') {
      let data = {
        // "userType":this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        "status": this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.DataMISReport(this.token, data, 'dataMIS')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })
    } else if (this.type == 'Contact MIS') {
      let data = {
        // "userType":this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        // "status":this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.DataMISReport(this.token, data, 'contactMIS')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    }
    else if (this.type == 'ClientEmail MIS') {
      let data = {
        // "userType":this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        // "status":this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.DataMISReport(this.token, data, 'clientEmailMIS')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    } else if (this.type == 'Live MIS') {
      let data = {
        // "userType":this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        // "status":this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.DataMISReport(this.token, data, 'liveMIS')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    }

    else if (this.type == 'Call Status MIS') {

      let telecallersArray = this.selectedTellecallers.map((item: any) => item._id);

      let data = {
        // "userType":this.usertype._id,
        "fromDate": this.fromDate,
        "toDate": this.toDate,
        "telecallerId": telecallersArray
        // "status":this.status
      }
      console.log(this.fromDate, this.toDate);
      this.loginService.DataMISReport(this.token, data, 'callStatusMIS')
        .subscribe((response: any) => {
          if (response.status === 1) {
            window.open(response.data, "_self")


          }
        })

    }

  }
  listUserType() {
    this.loginService.listUserType(this.token)
      .subscribe((response: any) => {
        if (response.status === 1) {
          this.userTypes = response.data
          console.log(this.userTypes);

          this.userTypes = this.userTypes.filter(
            (userType: any) => userType.userType === 'Tele Caller' || userType.userType === 'Field Executive' || userType.userType === 'Backend Staff'
          );
          this.userTypesTelleCaller = response.data.filter((userType: any) => userType.userType == 'Tele Caller');

          this.listPuncedTelleCaller()

        }
      })

  }

  listPuncedTelleCaller() {
    // console.log("knmn",this.userTypesTelleCaller);

    let req = {
      "userType": this.userTypesTelleCaller[0]._id,
      //  "key":"auto"


    }


    this.loginService.listStaffs1(this.token, req)
      .subscribe((response: any) => {
        if (response.status === 1) {
          // Swal.fire("Success")
          this.telleCallers = response.result
          // this.reminderToArray= this.telleCallers
          //  console.log("hfhfgkjh",this.PuncedStaffs);



        }
      }
      )
  }

   listStaffs() {

    this.loginService.listStaffs(this.token)
      .subscribe((response: any) => {
        if (response.status === 1) {
          this.users = response.data
        }
      });
    }

}
